export const API = {
  url: "https://api.mediawan.com/",
  base: "api/v1/front",
};
